import type { DeprecatedButtonTokens } from '../types';

export const deprecatedButton: DeprecatedButtonTokens = {
  colors: {
    darkButtonTextColor: '#B83E00',
    lightButtonBgColor: 'brandPrimary.0',
  },
};
